import { productGtmEvents } from '@/gtm/product';

export default {
  namespaced: true,

  state: () => ({
    selectedProduct: null,
    analyticsParams: {},
    selectedSize: {},
    isOverlayOpen: false,
    productQuickPickElement: null,
  }),

  getters: {
    availableSizes: (state) => state.selectedProduct?.skus || [],
    analyticsParams: (state) => state.analyticsParams,
    productQuickPickElement: (state) => state.productQuickPickElement,
    isOverlayOpen: (state) => state.isOverlayOpen,
  },

  mutations: {
    setAnalyticsParams(state, analyticsParams) {
      state.analyticsParams = analyticsParams;
    },

    clearAnalyticsParams(state) {
      state.analyticsParams = {
        title: null, label: null, slot: null, useAnalytics: null,
      };
    },
    setProduct(state, product) {
      state.selectedProduct = product;
    },

    clearSelectedProduct(state) {
      state.selectedProduct = null;
    },

    setSize(state, size) {
      state.selectedSize = size;
    },

    clearSelectedSize(state) {
      state.selectedSize = {};
    },

    setToOpen(state) {
      state.isOverlayOpen = true;
    },

    setToClose(state) {
      state.isOverlayOpen = false;
    },

    setModalQuickPickEl(state, el) {
      state.productQuickPickElement = el;
    },
  },

  actions: {
    async openOverlay({ commit }, {
      product, analyticsParams = {
        title: null,
        label: null,
        slot: null,
        useAnalytics: null,
      },
    }) {
      commit('setAnalyticsParams', analyticsParams);
      commit('setProduct', product);
      commit('setToOpen');
    },

    closeOverlay({ commit }) {
      commit('clearAnalyticsParams');
      commit('clearSelectedProduct');
      commit('clearSelectedSize');
      commit('setToClose');
    },

    selectSize({ commit, state }, size) {
      if (!state.analyticsParams.useAnalytics) {
        productGtmEvents.productListItem.onClickBasketAndSizeBtn({
          id: state.selectedProduct?.code,
          product_id: state.selectedProduct?.id,
        });
      }
      commit('setSize', size);
    },

    async addToCart({ dispatch, state }) {
      const cart = await dispatch('cart/add', {
        items: [{
          productId: state.selectedProduct?.id,
          quantity: 1,
          skuId: state.selectedSize?.id,
          product: state.selectedProduct,
        }],
      }, { root: true });

      if (!state.analyticsParams.useAnalytics) {
        productGtmEvents.productListItem.onClickBasketAndSizeBtnSuccess({
          id: state.selectedProduct?.code,
          product_id: state.selectedProduct?.id,
        });
      }

      return cart;
    },
  },
};
